/** Client-side normalized error (what the spas' api client throws). */
export class ApiError extends Error {
    status;
    code;
    details;
    requestId;
    constructor(status, code, message, details, requestId) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.details = details;
        this.requestId = requestId;
    }
}
//# sourceMappingURL=api.js.map